<header *ngIf="showMenu" class="no-print">
  <mat-toolbar color="4CAF50">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <mat-icon>more_vert</mat-icon>
    </button>

    <mat-menu #menu="matMenu">
      <div class="menu-title">
        <mat-icon>person</mat-icon>
        <span>{{ userName }}</span>
      </div>

      <button class="btn-menu" mat-menu-item (click)="onFullScreenClick()">
        <mat-icon>fullscreen</mat-icon>
        <span>Tela cheia</span>
      </button>

      <button class="btn-menu" mat-menu-item (click)="onCacheCleanClick()">
        <mat-icon>Cached</mat-icon>
        <span>Limpar o Cache</span>
      </button>

      <button class="btn-menu" mat-menu-item (click)="onLogoff()">
        <mat-icon>exit_to_app</mat-icon>
        <span>Sair</span>
      </button>
    </mat-menu>
  </mat-toolbar>
</header>

<div class="ibox-content text-center p-sm" [class.isMobile]="isMobile">
  <router-outlet></router-outlet>
</div>
